import { Platform, StatusBar, StyleSheet } from 'react-native'

import { moderateScale } from '../../styles/sizes'
import { color } from '../../theme'
import { fontFamily } from '../../theme/fontFamily'
import { DS } from '../../design-system'

export const styles = StyleSheet.create({
  mainContainer: {
    flex: 1,
    backgroundColor: DS.palette['Brand/Purple'],
    paddingTop: Platform.OS === 'android' ? StatusBar.currentHeight : 0
  },
  safeArea: {
    flex: 1
  },
  container: {
    paddingHorizontal: 24
  },
  headerContainer: {
    height: 64,
    width: '100%',
    backgroundColor: DS.palette['Brand/Purple'],
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  buttonContainer: {
    paddingVertical: 16
  },
  buttonText: {
    textAlign: 'center',
    fontWeight: '800',
    fontSize: 16,
    fontFamily: fontFamily.GTAmericaStandardMedium
  },
  errorMsg: { paddingTop: 10 },
  gradientButton: {
    flex: 1,
    borderRadius: 8,
    justifyContent: 'center',
    height: 55
  },
  inputField: {
    height: 48,
    backgroundColor: 'white',
    borderRadius: 5,
    fontSize: moderateScale(16),
    paddingStart: 10,
    marginTop: 6,
    borderColor: '#121212',
    borderWidth: 1,
    fontFamily: fontFamily.GTAmericaStandardRegular
  },
  backCopyText: {
    fontSize: moderateScale(14),
    fontFamily: fontFamily.GTAmericaStandardRegular,
    textTransform: 'uppercase',
    color: '#49CDF2'
  },
  heading: {
    fontSize: 28,
    fontFamily: fontFamily.FeatureDeckRegular,
    marginTop: 36,
    color: '#121212'
  },
  nameHeading: {
    fontSize: moderateScale(14),
    fontFamily: fontFamily.GTAmericaStandardMedium,
    marginTop: 16,
    color: '#121212'
  },
  dropdown: {
    width: '100%',
    height: 48,
    backgroundColor: 'white',
    borderRadius: 8,
    fontSize: moderateScale(16),
    paddingStart: 10,
    marginTop: 6,
    borderWidth: 1,
    borderColor: '#121212',
    fontFamily: fontFamily.FeatureDeckRegular
  },
  dropdownPickerImage: {
    width: 16,
    height: 16,
    resizeMode: 'contain',
    tintColor: color.primaryBlack
  },
  buttonStyle: {
    marginTop: 40,
    height: moderateScale(48),
    width: '100%',
    borderRadius: 48,
    alignSelf: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
    backgroundColor: '#5bc4ff'
  }
})
